import React, { useState, useEffect } from 'react';
import './EventFormModal.css';

export default function CCHEventFormModal({ onClose, onEventAdded, editData }) {
    const UPLOADS_BASE = 'https://www.fro.ro/api/uploads/';

    // ---------- STATE ----------
    const [formData, setFormData] = useState({
        name: '',
        start_date: '',
        end_date: '',
        location: '',
        registration_url: '',
        live_results: Array(6).fill(''),
        livelox_links: Array(6).fill(''),
        poster_image: '',
        bulletin_1: '',
        bulletin_2: '',
        bulletin_3: '',
        start_list_1: '',
        start_list_2: '',
        start_list_3: '',
        start_list_4: '',
        start_list_5: '',
        start_list_6: '',
        result_file_1: '',
        result_file_2: '',
        result_file_3: '',
        result_file_4: '',
        result_file_5: '',
        result_file_6: '',
        split_file_1: '',
        split_file_2: '',
        split_file_3: '',
        split_file_4: '',
        split_file_5: '',
        split_file_6: '',
    });

    const [files, setFiles] = useState({
        poster_image: null,
        bulletin_1: null,
        bulletin_2: null,
        bulletin_3: null,
        start_lists: Array(6).fill(null),
        results: Array(6).fill(null),
        splits: Array(6).fill(null),
    });

    // ---------- EFFECT: populate din editData ----------
    useEffect(() => {
        if (!editData) return;
        setFormData(prev => ({
            ...prev,
            name: editData.name || '',
            start_date: editData.start_date || '',
            end_date: editData.end_date || '',
            location: editData.location || '',
            registration_url: editData.registration_url || '',
            live_results: [
                editData.live_result_1 || '',
                editData.live_result_2 || '',
                editData.live_result_3 || '',
                editData.live_result_4 || '',
                editData.live_result_5 || '',
                editData.live_result_6 || '',
            ],
            livelox_links: [
                editData.livelox_url_1 || '',
                editData.livelox_url_2 || '',
                editData.livelox_url_3 || '',
                editData.livelox_url_4 || '',
                editData.livelox_url_5 || '',
                editData.livelox_url_6 || '',
            ],
            poster_image: editData.poster_image || '',
            bulletin_1: editData.bulletin_1 || '',
            bulletin_2: editData.bulletin_2 || '',
            bulletin_3: editData.bulletin_3 || '',
            start_list_1: editData.start_list_1 || '',
            start_list_2: editData.start_list_2 || '',
            start_list_3: editData.start_list_3 || '',
            start_list_4: editData.start_list_4 || '',
            start_list_5: editData.start_list_5 || '',
            start_list_6: editData.start_list_6 || '',
            result_file_1: editData.result_file_1 || '',
            result_file_2: editData.result_file_2 || '',
            result_file_3: editData.result_file_3 || '',
            result_file_4: editData.result_file_4 || '',
            result_file_5: editData.result_file_5 || '',
            result_file_6: editData.result_file_6 || '',
            split_file_1: editData.split_file_1 || '',
            split_file_2: editData.split_file_2 || '',
            split_file_3: editData.split_file_3 || '',
            split_file_4: editData.split_file_4 || '',
            split_file_5: editData.split_file_5 || '',
            split_file_6: editData.split_file_6 || '',
        }));
    }, [editData]);

    // ---------- HANDLERS ----------
    const handleInputChange = (e, index = null, key = null) => {
        const { name, value } = e.target;
        if (key === 'live_results' || key === 'livelox_links') {
            setFormData(prev => {
                const arr = [...prev[key]];
                arr[index] = value;
                return { ...prev, [key]: arr };
            });
            return;
        }
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e, key, index = null) => {
        const file = e.target.files?.[0] || null;
        if (index !== null) {
            setFiles(prev => ({
                ...prev,
                [key]: prev[key].map((f, i) => (i === index ? file : f)),
            }));
            return;
        }
        setFiles(prev => ({ ...prev, [key]: file }));
    };

    const handleDeleteAsset = async (field) => {
        if (!editData?.id) return;
        if (!window.confirm('Sigur vrei să ștergi acest fișier?')) return;

        const token =
            localStorage.getItem('cchToken') ||
            localStorage.getItem('adminToken');

        if (!token) {
            alert('Token lipsă. Te rugăm să te autentifici din nou.');
            return;
        }

        try {
            const res = await fetch('https://www.fro.ro/api/cch/delete_asset.php', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ event_id: editData.id, field }),
            });
            const out = await res.json();
            if (!res.ok || !out.success) {
                throw new Error(out.message || 'Nu s-a putut șterge fișierul.');
            }
            setFormData(prev => ({ ...prev, [field]: '' }));
            alert('Fișier șters.');
        } catch (err) {
            alert('Eroare: ' + err.message);
        }
    };

    const handleClearLink = (key, index) => {
        if (!window.confirm('Sigur vrei să golești acest link?')) return;
        setFormData(prev => {
            const arr = [...prev[key]];
            arr[index] = '';
            return { ...prev, [key]: arr };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const token =
            localStorage.getItem('cchToken') ||
            localStorage.getItem('adminToken');

        if (!token) {
            alert('Token CCH lipsă. Te rugăm să te autentifici din nou.');
            return;
        }

        const url = editData
            ? 'https://www.fro.ro/api/cch/edit_event.php'
            : 'https://www.fro.ro/api/cch/create_event.php';

        const data = new FormData();
        data.append('name', formData.name);
        data.append('start_date', formData.start_date);
        data.append('end_date', formData.end_date);
        data.append('location', formData.location);
        data.append('registration_url', formData.registration_url);
        if (editData?.id) data.append('id', editData.id);

        formData.live_results.forEach((val, i) => {
            if (val && val.trim() !== '') data.append(`live_result_${i + 1}`, val.trim());
        });

        formData.livelox_links.forEach((val, i) => {
            if (val && val.trim() !== '') data.append(`livelox_url_${i + 1}`, val.trim());
        });

        ['poster_image', 'bulletin_1', 'bulletin_2', 'bulletin_3'].forEach((key) => {
            if (files[key]) data.append(key, files[key]);
        });

        files.start_lists.forEach((file, i) => file && data.append(`start_list_${i + 1}`, file));
        files.results.forEach((file, i) => file && data.append(`result_file_${i + 1}`, file));
        files.splits.forEach((file, i) => file && data.append(`split_file_${i + 1}`, file));

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { Authorization: 'Bearer ' + token },
                body: data,
            });

            const text = await response.text();
            console.log('Răspuns primit de la server (CCH):', text);

            let result;
            try {
                result = JSON.parse(text);
            } catch {
                alert('Răspuns invalid de la server:\n\n' + text);
                return;
            }

            if (result.success) {
                alert(editData ? 'Campionat actualizat cu succes!' : 'Campionat adăugat cu succes!');
                onClose();
                if (onEventAdded) onEventAdded();
            } else {
                alert('Eroare: ' + (result.message || 'Operațiunea a eșuat.'));
            }
        } catch (error) {
            alert('Eroare rețea: ' + error.message);
        }
    };

    // ---------- RENDER ----------
    return (
        <div className="modal-backdrop">
            <div className="modal-box modal-box--xl">
                <form className="event-form event-form--roomy" onSubmit={handleSubmit}>
                    <div className="modal-head">
                        <h3>{editData ? 'Editează campionat național' : 'Adaugă campionat național'}</h3>
                        <button
                            type="button"
                            className="icon-close"
                            onClick={onClose}
                            aria-label="Închide"
                        >
                            ×
                        </button>
                    </div>

                    <div className="event-grid">
                        {/* === Informații de bază === */}
                        <section className="section-card">
                            <h4 className="section-title">Informații de bază</h4>
                            <div className="field-row">
                                <label>Nume</label>
                                <input
                                    type="text"
                                    name="name"
                                    required
                                    value={formData.name}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="field-row field-row--inline-2">
                                <div className="stack">
                                    <label>Dată început</label>
                                    <input
                                        type="date"
                                        name="start_date"
                                        required
                                        value={formData.start_date}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="stack">
                                    <label>Dată sfârșit</label>
                                    <input
                                        type="date"
                                        name="end_date"
                                        required
                                        value={formData.end_date}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="field-row">
                                <label>Locație</label>
                                <input
                                    type="text"
                                    name="location"
                                    required
                                    value={formData.location}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="field-row">
                                <label>Link înscrieri (opțional)</label>
                                <input
                                    type="url"
                                    name="registration_url"
                                    value={formData.registration_url}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </section>

                        {/* === Rezultate live === */}
                        <section className="section-card">
                            <h4 className="section-title">Rezultate live</h4>
                            <p className="helper">Poți adăuga până la 6 linkuri.</p>
                            {[...Array(6)].map((_, i) => (
                                <div key={i} className="field-row field-row--with-actions">
                                    <input
                                        type="url"
                                        placeholder={`Link rezultate live ${i + 1}`}
                                        value={formData.live_results[i]}
                                        onChange={(e) => handleInputChange(e, i, 'live_results')}
                                    />
                                    {formData.live_results[i] && (
                                        <div className="row-actions">
                                            <a
                                                href={formData.live_results[i]}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-ghost"
                                            >
                                                Deschide
                                            </a>
                                            <button
                                                type="button"
                                                className="btn btn-dark"
                                                onClick={() => handleClearLink('live_results', i)}
                                            >
                                                Golește
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </section>

                        {/* === Livelox === */}
                        <section className="section-card">
                            <h4 className="section-title">Linkuri Livelox</h4>
                            <p className="helper">Maxim 6 linkuri.</p>
                            {[...Array(6)].map((_, i) => (
                                <div key={i} className="field-row field-row--with-actions">
                                    <input
                                        type="url"
                                        placeholder={`Link Livelox ${i + 1}`}
                                        value={formData.livelox_links[i]}
                                        onChange={(e) => handleInputChange(e, i, 'livelox_links')}
                                    />
                                    {formData.livelox_links[i] && (
                                        <div className="row-actions">
                                            <a
                                                href={formData.livelox_links[i]}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-ghost"
                                            >
                                                Deschide
                                            </a>
                                            <button
                                                type="button"
                                                className="btn btn-dark"
                                                onClick={() => handleClearLink('livelox_links', i)}
                                            >
                                                Golește
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </section>

                        {/* === Poster === */}
                        <section className="section-card">
                            <h4 className="section-title">Afiș campionat</h4>
                            <label className="event-file-label">
                                Încarcă afișul
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleFileChange(e, 'poster_image')}
                                />
                            </label>
                            {files.poster_image && (
                                <span className="event-file-name">{files.poster_image.name}</span>
                            )}
                            {!files.poster_image && formData.poster_image && (
                                <div className="event-existing-asset">
                                    <img
                                        src={`${UPLOADS_BASE}${formData.poster_image}`}
                                        alt="Poster"
                                        className="poster-thumb"
                                    />
                                    <div className="event-asset-actions">
                                        <a
                                            href={`${UPLOADS_BASE}${formData.poster_image}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-ghost"
                                        >
                                            Deschide
                                        </a>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => handleDeleteAsset('poster_image')}
                                        >
                                            Șterge
                                        </button>
                                    </div>
                                </div>
                            )}
                        </section>

                        {/* === Buletine === */}
                        <section className="section-card">
                            <h4 className="section-title">Buletine PDF</h4>

                            {/* Upload (3 buc) */}
                            <div className="file-grid">
                                {[1, 2, 3].map(i => (
                                    <label key={i} className="event-file-label file-block">
                                        Încarcă buletin {i}
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            onChange={(e) => handleFileChange(e, `bulletin_${i}`)}
                                        />
                                    </label>
                                ))}
                            </div>

                            {/* LISTA fișierelor existente */}
                            {[1, 2, 3].map(i => {
                                const key = `bulletin_${i}`;
                                const file = formData[key];

                                return file ? (
                                    <div key={i} className="event-existing-asset file-item">
                                        <span>Buletin {i}:</span>
                                        <a
                                            href={`${UPLOADS_BASE}${file}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="link-file"
                                        >
                                            {file}
                                        </a>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => handleDeleteAsset(key)}
                                        >
                                            Șterge
                                        </button>
                                    </div>
                                ) : null;
                            })}
                        </section>

                        {/* === Liste start === */}
                        <section className="section-card">
                            <h4 className="section-title">Liste de start (max 6 PDF)</h4>

                            <div className="file-grid">
                                {[...Array(6)].map((_, i) => (
                                    <label key={i} className="event-file-label file-block">
                                        Încarcă listă {i + 1}
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            onChange={(e) => handleFileChange(e, 'start_lists', i)}
                                        />
                                    </label>
                                ))}
                            </div>

                            {[1, 2, 3, 4, 5, 6].map(i => {
                                const key = `start_list_${i}`;
                                const file = formData[key];
                                return file ? (
                                    <div key={i} className="event-existing-asset file-item">
                                        <span>Listă {i}:</span>
                                        <a
                                            href={`${UPLOADS_BASE}${file}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="link-file"
                                        >
                                            {file}
                                        </a>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => handleDeleteAsset(key)}
                                        >
                                            Șterge
                                        </button>
                                    </div>
                                ) : null;
                            })}
                        </section>

                        {/* === Rezultate === */}
                        <section className="section-card">
                            <h4 className="section-title">Fișiere rezultate (max 6 PDF)</h4>
                            <div className="file-grid">
                                {[...Array(6)].map((_, i) => (
                                    <label key={i} className="event-file-label file-block">
                                        Încarcă rezultat {i + 1}
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            onChange={(e) =>
                                                handleFileChange(e, 'results', i)
                                            }
                                        />
                                    </label>
                                ))}
                            </div>
                            {[1, 2, 3, 4, 5, 6].map(i => {
                                const key = `result_file_${i}`;
                                const file = formData[key];
                                return file ? (
                                    <div key={i} className="event-existing-asset">
                                        <span>Rezultat {i}:</span>
                                        <a
                                            href={`${UPLOADS_BASE}${file}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="link-file"
                                        >
                                            {file}
                                        </a>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => handleDeleteAsset(key)}
                                        >
                                            Șterge
                                        </button>
                                    </div>
                                ) : null;
                            })}
                        </section>

                        {/* === Splits === */}
                        <section className="section-card">
                            <h4 className="section-title">Fișiere rezultate split (max 6 PDF)</h4>
                            <div className="file-grid">
                                {[...Array(6)].map((_, i) => (
                                    <label key={i} className="event-file-label file-block">
                                        Încarcă split {i + 1}
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            onChange={(e) =>
                                                handleFileChange(e, 'splits', i)
                                            }
                                        />
                                    </label>
                                ))}
                            </div>
                            {[1, 2, 3, 4, 5, 6].map(i => {
                                const key = `split_file_${i}`;
                                const file = formData[key];
                                return file ? (
                                    <div key={i} className="event-existing-asset">
                                        <span>Split {i}:</span>
                                        <a
                                            href={`${UPLOADS_BASE}${file}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="link-file"
                                        >
                                            {file}
                                        </a>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => handleDeleteAsset(key)}
                                        >
                                            Șterge
                                        </button>
                                    </div>
                                ) : null;
                            })}
                        </section>
                    </div>

                    <div className="event-form-actions">
                        <button type="submit" className="btn btn-primary">
                            Salvează
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                        >
                            Anulează
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
